{
  "version": 1,
  "asset_id": "e2f218a4-216f-40a2-bea9-b95730ffed3f",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/e2f218a4-216f-40a2-bea9-b95730ffed3f/ind-security-automation-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/e2f218a4-216f-40a2-bea9-b95730ffed3f/ind-security-automation-640.webp",
  "original_filename": "ind-security-automation-640.webp",
  "size": 4152,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:15Z"
}
